import { qualityMessage } from "../../utils/directorFormat";

const selectedId = (items, value) => (
  items.find((item) => String(item.id) === String(value))?.id ?? null
);

const ReceivablesFilters = ({
  metadata = {},
  filters = {},
  receivableFilters = {},
  customerOptions = [],
  unitOptions = [],
  periodMonths = 36,
  basisOptions = {},
  onFiltersChange,
  onReceivableFiltersChange,
  onPeriodMonthsChange,
}) => {
  const entities = metadata.legalEntities || [];
  const projects = (metadata.projects || []).filter((project) => (
    filters.legalEntityId === null
    || filters.legalEntityId === undefined
    || String(project.legalEntityId) === String(filters.legalEntityId)
  ));
  const corrected = basisOptions.corrected || { state: "unavailable" };
  const correctedDisabled = corrected.state !== "available";
  const basisHelp = correctedDisabled
    ? "A base corrigida permanece indisponível até recebido e previsto usarem a mesma base."
    : "Nominal e corrigida usam revisões monetárias separadas.";
  const selectedUnit = receivableFilters.unitRef && !unitOptions.some((item) => (
    item.value === receivableFilters.unitRef
  )) ? [{ value: receivableFilters.unitRef, label: "Unidade selecionada" }] : [];
  const selectedCustomer = receivableFilters.customerRef && !customerOptions.some((item) => (
    item.value === receivableFilters.customerRef
  )) ? [{ value: receivableFilters.customerRef, label: "Cliente selecionado" }] : [];

  return <section
    aria-label="Filtros de clientes e recebimentos"
    className="director-filters director-receivables-filters"
  >
    <div className="director-filter-field">
      <label htmlFor="receivables-entity">Empresa / SPE</label>
      <select
        id="receivables-entity"
        onChange={(event) => {
          onFiltersChange?.({
            ...filters,
            legalEntityId: selectedId(entities, event.target.value),
            projectKey: null,
            costCenterId: null,
          });
          onReceivableFiltersChange?.({ customerRef: null, unitRef: null, page: 1 });
        }}
        value={filters.legalEntityId ?? ""}
      >
        <option value="">Todas</option>
        {entities.map((entity) => <option key={entity.id} value={entity.id}>{entity.name}</option>)}
      </select>
    </div>

    <div className="director-filter-field">
      <label htmlFor="receivables-project">Empreendimento</label>
      <select
        id="receivables-project"
        onChange={(event) => {
          onFiltersChange?.({
            ...filters,
            projectKey: event.target.value || null,
            costCenterId: null,
          });
          onReceivableFiltersChange?.({ customerRef: null, unitRef: null, page: 1 });
        }}
        value={filters.projectKey ?? ""}
      >
        <option value="">Todos</option>
        {projects.map((project) => <option key={project.key} value={project.key}>{project.name}</option>)}
      </select>
    </div>

    <div className="director-filter-field">
      <label htmlFor="receivables-customer">Cliente</label>
      <select
        id="receivables-customer"
        onChange={(event) => onReceivableFiltersChange?.({
          customerRef: event.target.value || null,
          unitRef: null,
          page: 1,
        })}
        value={receivableFilters.customerRef ?? ""}
      >
        <option value="">Todos</option>
        {[...selectedCustomer, ...customerOptions].map((item) => (
          <option key={item.value} value={item.value}>{item.label}</option>
        ))}
      </select>
    </div>

    <div className="director-filter-field">
      <label htmlFor="receivables-unit">Unidade</label>
      <select
        id="receivables-unit"
        onChange={(event) => onReceivableFiltersChange?.({
          unitRef: event.target.value || null,
          page: 1,
        })}
        value={receivableFilters.unitRef ?? ""}
      >
        <option value="">Todas</option>
        {[...selectedUnit, ...unitOptions].map((item) => (
          <option key={item.value} value={item.value}>{item.label}</option>
        ))}
      </select>
    </div>

    <div className="director-filter-field">
      <label htmlFor="receivables-period">Período</label>
      <select
        id="receivables-period"
        onChange={(event) => {
          onPeriodMonthsChange?.(Number(event.target.value));
          onReceivableFiltersChange?.({ page: 1 });
        }}
        value={periodMonths}
      >
        <option value="12">12 meses</option>
        <option value="24">24 meses</option>
        <option value="36">36 meses</option>
      </select>
    </div>

    <div className="director-filter-field">
      <label htmlFor="receivables-basis">Base dos valores</label>
      <select
        aria-describedby="receivables-basis-help"
        id="receivables-basis"
        onChange={(event) => onReceivableFiltersChange?.({
          basis: event.target.value,
          page: 1,
        })}
        value={receivableFilters.basis ?? "nominal"}
      >
        <option value="nominal">Nominal</option>
        <option disabled={correctedDisabled} value="corrected">Corrigida</option>
      </select>
      <small id="receivables-basis-help">
        {corrected.reasonCode === "received_not_normalized_to_corrected_basis"
          ? basisHelp
          : correctedDisabled ? qualityMessage("monetary_basis_incomplete") : basisHelp}
      </small>
    </div>
  </section>;
};

export default ReceivablesFilters;
